<template>
  <div :id="data.id" style="width:100%; height: 100%"></div>
</template>
<script>
  import DefaultJs from './Default.js'

  export default DefaultJs
</script>

 


// WEBPACK FOOTER //
// Default.vue?442c335c